import { format, parseISO } from 'date-fns';
import { Box, IconButton, Popover, TableCell } from '@mui/material';

import { TableRow } from '@mui/material';
import { Link } from 'react-router';
import { PublishState } from '../../components';
import { Star } from '@phosphor-icons/react';
import { useState } from 'react';
import { Api, useApiCallable } from '../../api';
import { Model } from '../../models';

type Props = {
  article: Api.LibraryContent.V_ListAsAdmin;
};

export default function ArticleRow({ article }: Props) {
  const callApi = useApiCallable();

  const [isFeatured, setIsFeatured] = useState(article.isFeatured);

  const [starPopoverAnchor, setStarPopoverAnchor] =
    useState<HTMLElement | null>(null);

  const handleStarMouseEnter = (e: React.MouseEvent<HTMLElement>) => {
    setStarPopoverAnchor(e.currentTarget);
  };
  const handleStarMouseLeave = () => {
    setStarPopoverAnchor(null);
  };

  const handleToggleFeatured = () => {
    callApi(
      isFeatured
        ? `/library-contents/${article.id}/mark-as-unfeatured`
        : `/library-contents/${article.id}/mark-as-featured`,
      {
        method: 'POST',
        jsonBody: {},
      },
    );
    setIsFeatured(!isFeatured);
  };

  return (
    <>
      <TableRow
        component={Link}
        to={`/library/${article.id}`}
        sx={{
          cursor: 'pointer',
          textDecoration: 'none',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
      >
        <TableCell>{article.title}</TableCell>
        <TableCell>
          <PublishState item={{ publishAt: article.publishedAt }} />
        </TableCell>
        <TableCell>
          {
            Model.LibraryContent.TYPE_OPTIONS.find(
              (option) => option.value === article.type,
            )?.label
          }
        </TableCell>
        <TableCell>
          {Array.isArray(article.internalTags) ? (
            <Box
              sx={{
                display: 'flex',
                gap: 1,
                flexWrap: 'wrap',
              }}
            >
              {article.internalTags.map((tag) => (
                <span
                  key={tag.id}
                  style={{
                    display: 'inline-block',
                    background: '#eee',
                    borderRadius: 8,
                    padding: '2px 8px',
                    fontSize: 12,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {tag.category.name}/{tag.internalName}
                </span>
              ))}
            </Box>
          ) : null}
        </TableCell>
        <TableCell>
          {article.updatedAt
            ? format(parseISO(article.updatedAt), 'dd MMM yyyy, HH:mm')
            : ''}
        </TableCell>
        <TableCell align="center">
          <span
            onMouseEnter={handleStarMouseEnter}
            onMouseLeave={handleStarMouseLeave}
            style={{ display: 'inline-block' }}
          >
            <IconButton
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleToggleFeatured();
              }}
            >
              {isFeatured ? (
                <Star color="#FFC107" size={24} weight="fill" />
              ) : (
                <Star color="#667085" size={24} />
              )}
            </IconButton>
          </span>
        </TableCell>
      </TableRow>
      <Popover
        sx={{ pointerEvents: 'none' }}
        open={Boolean(starPopoverAnchor)}
        anchorEl={starPopoverAnchor}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        disableRestoreFocus
        PaperProps={{
          sx: { pointerEvents: 'auto', p: 2, maxWidth: 260 },
        }}
      >
        <div>
          <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 4 }}>
            {article.isFeatured
              ? 'Unfeature this content'
              : 'Feature this content'}
          </div>
          <div style={{ color: '#667085', fontSize: 14 }}>
            {article.isFeatured
              ? 'this will remove the content from the "Featured" section'
              : 'this means it will show up in the "Featured" section of the app'}
          </div>
        </div>
      </Popover>
    </>
  );
}
